import { FunctionComponent, ReactNode } from "react"
import * as Tooltip from "@radix-ui/react-tooltip"
import styles from "./radixTooltip.module.scss"
import classNames from "classnames"

export interface RadixToolTipI {
    triggerChildren: ReactNode
    tooltipContent: ReactNode
    customTooltipContentStyles?: string
    side?: "top" | "right" | "bottom" | "left"
    renderDelay?: number
}

const ToolTip: FunctionComponent<RadixToolTipI> = ({
    triggerChildren,
    tooltipContent,
    customTooltipContentStyles,
    side = "top",
    renderDelay = 300,
}) => {
    return (
        <>
            <Tooltip.Provider delayDuration={renderDelay}>
                <Tooltip.Root>
                    <Tooltip.Trigger asChild>{triggerChildren}</Tooltip.Trigger>
                    <Tooltip.Portal>
                        <Tooltip.Content
                            className={classNames(
                                styles.tooltipContent,
                                customTooltipContentStyles &&
                                    customTooltipContentStyles
                            )}
                            side={side}
                        >
                            {tooltipContent}
                            <Tooltip.Arrow className={styles.tooltipArrow} />
                        </Tooltip.Content>
                    </Tooltip.Portal>
                </Tooltip.Root>
            </Tooltip.Provider>
        </>
    )
}

export default ToolTip
